import React from 'react';
import { ScenePreview } from './scene-preview';
import { ResolutionSelector } from './resolution-selector';
import { PlacaSelector } from './placa-selector';
import { MusicTrackSelector } from './music-track-selector';
import { SubtitlesSelector } from './subtitles-selector';
import { SummarySection } from './summary-section';
import { useEditorContext } from '../../context/editor-context';

export const SettingsPanel: React.FC = () => {
  const {
    selectedResolution,
    setSelectedResolution,
    selectedPlacaId,
    setSelectedPlacaId,
    selectedMusicTrackId,
    setSelectedMusicTrackId,
    editingProjectId,
    enableSubtitles,
    setEnableSubtitles
  } = useEditorContext();

  const isEditMode = editingProjectId !== null;

  return (
    <div>
      <ScenePreview />
      <ResolutionSelector selected={selectedResolution} onChange={setSelectedResolution} disabled={isEditMode} />
      <PlacaSelector selected={selectedPlacaId} onChange={setSelectedPlacaId} />
      <MusicTrackSelector selected={selectedMusicTrackId} onChange={setSelectedMusicTrackId} />
      <SubtitlesSelector checked={enableSubtitles} onChange={setEnableSubtitles} />
      <SummarySection selectedResolutions={1} />
    </div>
  );
};
